export class CallRecordingConfiguration {
  constructor(public readonly enabled: boolean) {}
}
